<template>
  <MainLayout>
    <v-layout style="padding: 1em" justify-center row fill-height>
      <v-flex>
        <v-card style="height: 100%" light color="#f4f4fa">
          <v-layout column style="height: 100%">
            <!-- Title -->
            <v-card-title row>
              <span class="title font-weight-light">Departments</span>
            </v-card-title>

            <!-- Searching, Actions -->
            <div class="d-flex justify-end align-center px-4">
              <v-text-field
                label="Search by name, header (email, name, phone, designation)"
                class="flex-none mr-2"
                style="width: 40%"
                v-model="filters.q"
                @input="getDepartments"
                prepend-icon="search"
                clearable
              />

              <v-space />

              <v-btn
                v-if="isEditable"
                @click="
                  editDialogVisible = true;
                  resetForm();
                "
                class="flex-none"
                color="primary"
                ><v-icon>add</v-icon>
                Add Department
              </v-btn>
            </div>

            <!-- Table -->
            <v-container fluid fill-height class="full-height">
              <v-layout style="padding: 0" class="full-height">
                <v-flex sm12 md12 class="full-height scroll">
                  <v-data-table
                    :headers="headers"
                    :items="departments"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[10, 50, 100]"
                    :total-items="pagination.totalItems"
                    :loading="loading"
                    @update:pagination="getDepartments"
                    class="elevation-1"
                  >
                    <!-- When items = [] -->
                    <template v-slot:no-data>
                      <div style="text-align: center">
                        {{
                          loading
                            ? "Please wait a moment "
                            : "No matching records found"
                        }}
                      </div>
                    </template>

                    <!-- When items = undefined -->
                    <template v-slot:no-results>
                      <div style="text-align: center">
                        {{
                          loading
                            ? "Please wait a moment "
                            : "Data will be displayed in here"
                        }}
                      </div>
                    </template>

                    <template v-slot:items="props">
                      <td>{{ props.index + 1 }}</td>
                      <td>{{ props.item.name }}</td>
                      <td>
                        {{ props.item.manager ? props.item.manager.name : "" }}
                      </td>
                      <td>
                        {{
                          props.item.manager ? props.item.manager.position : ""
                        }}
                      </td>
                      <td>
                        {{ props.item.manager ? props.item.manager.email : "" }}
                        <!-- <v-btn  icon :title="props.item.manager.email" :href="'mailto:'+props.item.manager.email">
                          <v-icon color="blue">email</v-icon>
                        </v-btn> -->
                      </td>
                      <td>
                        {{
                          props.item.manager ? props.item.manager.mobile : ""
                        }}
                        <!-- <v-btn icon :title="props.item.manager.mobile" :href="'tel:'+props.item.manager.mobile">
                          <v-icon color="blue">phone</v-icon>
                        </v-btn> -->
                      </td>
                      <td v-if="isEditable">
                        <v-btn @click="editItem(props.item)" icon title="Edit">
                          <v-icon color="warning">edit</v-icon>
                        </v-btn>

                        <v-btn
                          @click="confirmDelete(props.item)"
                          icon
                          title="Delete"
                        >
                          <v-icon color="error">delete</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Add/Edit Department Dialog -->
    <v-dialog v-model="editDialogVisible" width="37.5em">
      <v-flex light sm12 md12 class="full-height scroll">
        <!-- Header -->
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{
              form.id ? "Edit Department" : "Create New Department"
            }}</v-toolbar-title
          >
          <v-spacer />
          <v-btn icon @click="editDialogVisible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Content -->
        <v-card light>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <!-- Department -->
              <div class="form-item-view">
                <strong class="form-item-label">Department Name</strong>
                <v-text-field
                  v-model="form.department_name"
                  :error-messages="errors.department_name"
                  placeholder="Department Name"
                />
              </div>

              <!-- Password -->
              <div class="form-item-view">
                <strong class="form-item-label">Password</strong>
                <v-text-field
                  browser-autocomplete="new-password"
                  :type="'password'"
                  :error-messages="errors.password"
                  v-model="form.password"
                  placeholder="Password"
                />
              </div>

              <div class="form-item-view">
                <strong class="form-item-label">
                  Confirm Password
                </strong>

                <v-text-field
                  browser-autocomplete="new-password"
                  :type="'password'"
                  placeholder="Re-type Password"
                  :error-messages="errors.password_confirmation"
                  v-model="form.password_confirmation"
                />
              </div>

              <div
                class="form-item-view"
                style="display: flex; width: 100%; justify-content: flex-end"
              >
                <v-btn
                  v-if="onEdit"
                  :loading="updatePasswordLoading"
                  color="primary"
                  @click="updatePassword"
                >
                  Change Password
                </v-btn>
              </div>

              <v-divider />

              <!-- Contact Person -->
              <div class="title font-weight-bold mt-4">
                CONTACT PERSON DETAILS
              </div>

              <!-- Contact Person Info -->
              <div class="form-item-view">
                <strong class="form-item-label">
                  Full Name
                  <span style="color: var(--danger)">*</span>
                </strong>

                <v-text-field
                  v-model="form.name"
                  :error-messages="errors.name"
                  placeholder="Enter Name"
                />
              </div>

              <div class="form-item-view">
                <strong class="form-item-label">
                  Email
                  <span style="color: var(--danger)">*</span>
                </strong>

                <v-text-field
                  :rules="[rules.email]"
                  v-model="form.email"
                  placeholder="Enter Email"
                  :error-messages="errors.email"
                />
              </div>

              <div class="form-item-view">
                <strong class="form-item-label">
                  Phone No.
                  <span style="color: var(--danger)">*</span>
                </strong>

                <v-text-field
                  v-model="form.mobile"
                  mask="##### #####"
                  prefix="+91"
                  :error-messages="errors.mobile"
                  placeholder="Enter Phone"
                />
              </div>

              <div class="form-item-view">
                <strong class="form-item-label">
                  Designation
                  <span style="color: var(--danger)">*</span>
                </strong>

                <v-text-field
                  v-model="form.position"
                  :error-messages="errors.position"
                  placeholder="Enter Designation"
                />
              </div>

              <div
                class="form-item-view"
                style="display: flex; width: 100%; justify-content: flex-end"
              >
                <v-btn flat @click="editDialogVisible = false">Cancel</v-btn>

                <v-btn
                  v-if="onEdit"
                  :loading="updateLoading"
                  color="primary"
                  @click="updateInformation"
                >
                  Update Info
                </v-btn>

                <v-btn
                  v-if="!onEdit"
                  :loading="updateLoading"
                  color="primary"
                  @click="submitForm"
                >
                  Create
                </v-btn>
              </div>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-dialog>
  </MainLayout>
</template>

<script>
import moment from "moment";
import api from "@/api";
import { debounce } from "@/utils/Debounce";
import { mapState } from "vuex";
import { PLATFORMS } from "@/constants/platforms";

export default {
  metaInfo: {
    title: "Departments",
    meta: [{ name: "Departments", content: "departments management" }]
  },

  data() {
    return {
      // List
      loading: false,
      departments: undefined,

      filters: {
        q: undefined
      },

      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0
      },

      // Users
      fetchingUsers: false,
      users: [],

      // Form
      editDialogVisible: false,
      onEdit: false,
      updateLoading: false,
      updatePasswordLoading: false,
      createNew: false,
      departmentHeaderAssignmentMode: 0,
      form: {},
      errors: {},
      rules: {
        required: value => !!value || "Required.",
        counter: value => (value && value.length <= 10) || "Max 10 characters",
        email: value => {
          if (!value) return true;

          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),

    defaultAvatar() {
      return require("@/assets/images/avatar.png");
    },

    userItems() {
      return this.users.reduce((items, user) => {
        items.push({
          id: user.id,
          avatar: user.avatar || this.defaultAvatar,
          title: user.name,
          subtitle: `
            <div style="display: flex; align-items: center">
              <span class="mr-2" style="display: flex; align-items: center">
                <i class="material-icons" style="font-size: 1em">phone</i> <span class="ml-1">${
                  user.mobile
                }</span>
              </span>
              <span class="mr-2" style="display: flex; align-items: center">
                <i class="material-icons" style="font-size: 1em">email</i> <span class="ml-1">${
                  user.email
                }</span>
              </span>
              <span class="mr-2" style="display: flex; align-items: center">
                <i class="material-icons" style="font-size: 1em">home</i> <span class="ml-1">${user.department &&
                  user.department.name}</span>
              </span>
            </div>
          `
        });

        items.push({
          divider: true,
          inset: true
        });

        return items;
      }, []);
    },

    isEditable() {
      return this.currentUser.platform == PLATFORMS.ADMINISTRATION;
    },

    headers() {
      const result = [
        {
          text: "Department ID",
          width: 120,
          sortable: false
        },
        {
          text: "Department",
          sortable: false
        },
        {
          text: "Contact Persons",
          sortable: false
        },
        {
          text: "Designations",
          sortable: false
        },
        {
          text: "Email",
          sortable: false
        },
        {
          text: "Phone",
          width: 100,
          sortable: false
        }
      ];

      if (this.isEditable) {
        result.push({
          text: "Action",
          sortable: false
        });
      }

      return result;
    }
  },

  watch: {
    editDialogVisible(val) {
      if (!val) {
        this.clearDialogForm();
      }
    }
  },

  created() {
    this.getDepartments();
  },

  methods: {
    clearDialogForm() {
      this.form = {};
      this.errors = {};
    },

    convertTime(utcStr) {
      return moment
        .parseZone(utcStr, "YYYY-MM-DD HH:mm:ss", "UTC")
        .toDate()
        .toLocaleTimeString();
    },

    convertDate(utcStr) {
      return moment
        .parseZone(utcStr, "YYYY-MM-DD HH:mm:ss", "UTC")
        .toDate()
        .toLocaleDateString();
    },

    resetForm() {
      this.onEdit = false;
      this.form = {
        id: undefined,
        user_id: undefined,
        department_name: undefined,
        name: undefined,
        password: undefined,
        password_confirmation: undefined,
        mobile: undefined,
        email: undefined,
        position: undefined
      };
    },

    async submitForm() {
      try {
        this.errors = {};
        this.updateLoading = true;
        await api.addDepartments(this.form);

        this.updateLoading = false;
        this.$notify.success("The department has been created");
        this.resetForm();
        this.getDepartments();

        this.editDialogVisible = false;
      } catch (e) {
        console.error(e);

        if (e.errors) {
          this.errors = e.errors;
        } else {
          this.$notify.error(e.message);
        }
      } finally {
        this.updateLoading = false;
      }
    },

    async updateInformation() {
      try {
        this.errors = {};
        this.updateLoading = true;

        if (this.departmentHeaderAssignmentMode === 0) {
          await api.updateDepartments(this.form.id, {
            user_id: this.form.user_id,
            department_name:
              this.form.department_name && this.form.department_name.trim(),
            name: this.form.name,
            mobile: this.form.mobile,
            email: this.form.email,
            position: this.form.position
          });
        } else {
          await api.updateExistingUserDepartments(
            this.form.user_id,
            this.form.id,
            {
              department_name:
                this.form.department_name && this.form.department_name.trim(),
              position: this.form.position
            }
          );
        }

        this.$notify.success("The department information has been updated");
        this.getDepartments();

        this.editDialogVisible = false;
      } catch (e) {
        console.error(e);

        if (e.errors) {
          this.errors = e.errors;
        } else {
          this.$notify.error(e.message);
        }
      } finally {
        this.updateLoading = false;
      }
    },

    async updatePassword() {
      try {
        this.errors = {};
        this.updatePasswordLoading = true;
        await api.updatePassword(this.form.user_id, {
          password: this.form.password,
          password_confirmation: this.form.password_confirmation
        });

        this.$notify.success("The password has been updated");
        this.form.password = "";
        this.form.password_confirmation = "";
        this.getDepartments();
      } catch (e) {
        console.error(e);

        if (e.errors) {
          this.errors = e.errors;
        } else {
          this.$notify.error(e.message);
        }
      } finally {
        this.updatePasswordLoading = false;
      }
    },

    getDepartments: debounce(async function() {
      try {
        this.loading = true;
        this.departments = undefined;

        const res = await api.getDepartments({
          q: this.filters.q || undefined,
          page_size: this.pagination.rowsPerPage,
          page: this.pagination.page
        });

        this.departments = res.data.data;

        this.pagination.totalItems = res.data.total;
      } finally {
        this.loading = false;
      }
    }, 500),

    editItem(department) {
      this.editDialogVisible = true;
      this.onEdit = true;

      this.form = {
        id: department.id,
        user_id: department.manager && department.manager.id,
        department_name: department.name && department.name.trim(),
        name: department.manager && department.manager.name,
        password: undefined,
        password_confirmation: undefined,
        mobile: department.manager && department.manager.mobile,
        email: department.manager && department.manager.email,
        position: department.manager && department.manager.position
      };
    },

    async confirmDelete(department) {
      try {
        await this.$confirm(
          "Are you sure delete department, all relation data of department will lose?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        );

        this.deleteDepartment(department);
      } catch (error) {
        // Ignore
      }
    },

    async deleteDepartment(department) {
      try {
        this.loading = true;

        await api.deleteDepartment(department.id);

        this.$notify.success("Department has been successfully deleted.");
        this.getDepartments();
      } catch (error) {
        this.$notify.error(error.message);
      } finally {
        this.loading = false;
      }
    },

    // Users
    async getUsersForDepartmentHeader(query) {
      if (!query || query.length === 0) {
        this.users = [];
        return;
      }

      try {
        this.users = [];
        this.fetchingUsers = true;

        const res = await api.getHeaderUsers({
          search: query
        });

        this.users = res.data.data;
      } finally {
        this.fetchingUsers = false;
      }
    }
  }
};
</script>

<style lang="css" scoped>
.form-item-view {
  display: flex;
  width: 100%;
  align-items: center;
}
.form-item-label {
  width: 10em;
  text-align: left;
  margin-right: 1.25em;
  /* margin-bottom: 1.25em; */
}
.header-contact {
  font-size: 1.25em;
  margin-bottom: 0.625em;
}
.full-height {
  flex: 1 1 auto;
  min-height: 0;
}
.scroll {
  overflow-y: auto;
}
</style>
